import React, { Component } from 'react';
import { Typography, Grid, TextField } from '@material-ui/core';
import { WrongEmailFormatText, validateEmail, validatePassword } from '../../Common';

type Props = {
    update: (isValid: boolean) => void
}
type State = {
    password: string,
    password2: string,
    passwordsMatch: boolean | null,
    passwordFormatError: boolean,
    message: string,
    email: string,
    emailFormatError: boolean,
    contactPersonName: string,
    contactPersonSurname: string
}

class UserInformationForm extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            password: '',
            password2: '',
            passwordsMatch: null,
            passwordFormatError: false,
            message: '',
            email: '',
            emailFormatError: false,
            contactPersonName: '',
            contactPersonSurname: ''
        }
    }

    componentDidMount() {
        this.props.update(this.isValid(this.state))
    }


    componentDidUpdate(prevProps: Props, prevState: State) {
        if (this.isValid(prevState) !== this.isValid(this.state))
            this.props.update(this.isValid(this.state))
    }

    isValid = (state: State): boolean => {
        let valid: boolean = (!state.passwordFormatError && !state.emailFormatError && state.passwordsMatch === true && state.password !== '' && state.email !== '' && state.contactPersonName !== '' && state.contactPersonSurname !== '')
        return valid
    }

    render() {
        return (
            <div>
                <Grid container style={{ textAlign: 'center', padding: "15px" }}>
                    <Grid item xs={12} sm={12} md={12}>
                        <Typography variant="h4" color="error">{this.state.message}</Typography>
                    </Grid>
                    <Grid item sm={3} md={4}></Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            label="Name*"
                            type="name"
                            name="name"
                            margin="normal"
                            variant="outlined"
                            value={this.state.contactPersonName}
                            onChange={(e) => this.setState({ contactPersonName: e.target.value })}
                            style={{ width: '100%' }}
                        />

                        <TextField
                            label="Surname*"
                            type="surname"
                            name="surname"
                            margin="normal"
                            variant="outlined"
                            value={this.state.contactPersonSurname}
                            onChange={(e) => this.setState({ contactPersonSurname: e.target.value })}
                            style={{ width: '100%' }}
                        />
                        
                        <div>
                            <TextField
                                label="E-mail address*"
                                type="email"
                                name="email"
                                autoComplete="email"
                                margin="normal"
                                variant="outlined"
                                value={this.state.email}
                                onChange={(e) => this.setState({ email: e.target.value, emailFormatError: !validateEmail(e.target.value) })}
                                style={{ width: '100%' }}
                                helperText={this.state.emailFormatError ? WrongEmailFormatText : ''}
                                error={this.state.emailFormatError}
                            />
                        </div>
                        <div>
                            <TextField
                                label="Your password*"
                                type="password"
                                autoComplete="current-password"
                                margin="normal"
                                variant="outlined"
                                value={this.state.password}
                                onChange={(e) => this.setState({ password: e.target.value, passwordFormatError: !validatePassword(e.target.value) })}
                                style={{ width: '100%' }}
                                helperText={this.state.passwordFormatError ? "Password have to consist of at least 8 characters, 1 uppercase, 1 lowercase, 1 numeric, and 1 special character." : ''}
                                error={this.state.passwordFormatError}
                            />
                            <TextField
                                label="Confirm your password*"
                                type="password"
                                autoComplete="current-password"
                                margin="normal"
                                variant="outlined"
                                value={this.state.password2}
                                onChange={(e) => this.setState({ password2: e.target.value, passwordsMatch: this.state.password === e.target.value })}
                                style={{ width: '100%' }}
                                helperText={this.state.passwordsMatch === null ? '' : (this.state.passwordsMatch ? '' : "Passwords are not matching.")}
                                error={this.state.passwordsMatch === null ? false : !this.state.passwordsMatch}
                            />
                        </div>
                    </Grid>

                    <Grid item xs={12}></Grid>

                </Grid>
            </div>
        );
    }
}
export default UserInformationForm;